module.exports = __webpack_public_path__ + "img/favorites_modal.ac544efd.png";